// Fee percentages in public copy come from the city-config payload
// (`city_config.fee_program`, filled on the Rails side per backlog D1 / C9),
// never from a literal in this tree (backlog E11, brief rule "every number
// comes from config"). Until the payload carries a value the sentence renders
// without the number: "the service fee" rather than "the 5% service fee".
//
// Keys read, named after the CateringBooking constants they replace:
//   fee_program.catering_service_fee_percent   customer side (SERVICE_FEE_RATE)
//   fee_program.catering_commission_percent    vendor side (COMMISSION_RATE)
// A value at or below 1 is taken as a fraction (0.05 -> 5).

export const CATERING_SERVICE_FEE_KEY = 'catering_service_fee_percent';
export const CATERING_COMMISSION_KEY = 'catering_commission_percent';

// "5", "7.5", or null when the payload has no usable value.
export function feePercent(config, key) {
  const program = config && config.fee_program;
  const raw = program ? program[key] : undefined;
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) return null;
  const pct = n <= 1 ? n * 100 : n;
  const rounded = Math.round(pct * 100) / 100;
  return String(rounded);
}

// "5% service fee" when the payload carries the rate, "service fee" when it
// does not, so a sentence reads correctly either way.
export function feeLabel(config, key, noun = 'service fee') {
  const pct = feePercent(config, key);
  return pct ? `${pct}% ${noun}` : noun;
}
